/**
 * When a select value is changed, submit its parent form
 *
 */
export default () => {
  const selects = Array.from(document.querySelectorAll('.js-submit-on-change'));

  selects.forEach((select) => {
    select.addEventListener('change', (e) => {
      e.currentTarget.form.submit();
    });
  });
};
